import styled from 'styled-components';

import { theme } from '_constants/theme';
import { ICONS_ALIASES, ICONS_PALETTE } from '_constants/icons';

import FancyCards from '_components/atomic/FancyCards';

const { colors, devices, fontSizes, spaces } = theme;

const ITEMS = [
  {
    title: 'Expertise and experience',
    description: (
      <>
        Our team of experts has years of experience in the field of business
        incorporation and is dedicated to providing personalized service and
        guidance to ensure your success.
      </>
    ),
    iconAlias: ICONS_ALIASES.feedback,
    iconPalette: ICONS_PALETTE.green[ICONS_ALIASES.feedback],
    color: colors.green[25],
  },
  {
    title: 'One-stop-shop',
    description: (
      <>
        We offer a wide range of services from incorporation to ongoing
        compliance and legal requirements, as well as trademark registration,
        bookkeeping, merchant processing and more, making it easy for you to
        manage your business.
      </>
    ),
    iconAlias: ICONS_ALIASES.shop,
    iconPalette: ICONS_PALETTE.indigo[ICONS_ALIASES.shop],
    color: colors.indigo[25],
  },
  {
    title: 'Efficiency and convenience',
    description: (
      <>
        Our easy-to-use questionnaire and simple 4-step process makes
        incorporating your business quick and stress-free, and our online
        platform allows you to access your documents and information anytime,
        anywhere.
      </>
    ),
    iconAlias: ICONS_ALIASES.saveEnergy,
    iconPalette: ICONS_PALETTE.indigo[ICONS_ALIASES.saveEnergy],
    color: colors.indigo[25],
  },
  {
    title: 'Affordability',
    description: (
      <>
        Our competitive pricing and flexible filing packages offer the best
        value for your money compared to other incorporation services, making it
        more affordable for small businesses to incorporate and stay compliant
        with the state regulations.
      </>
    ),
    iconAlias: ICONS_ALIASES.chart,
    iconPalette: ICONS_PALETTE.green[ICONS_ALIASES.chart],
    color: colors.green[25],
  },
];

const StyledWhyShouldUseUsSection = styled.div`
  max-width: ${spaces.large24X * 10 + 80}px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${devices.tablet} {
    padding: ${spaces.regular}px;
  }
`;

const StyledTitle = styled.div`
  margin-bottom: ${spaces.large9X}px;
  font-family: 'Aeonik';
  font-style: normal;
  font-weight: 500;
  font-size: ${fontSizes.large11X}px;
  line-height: 150%;
  text-align: center;
  color: ${colors.gray[800]};

  @media ${devices.tablet} {
    margin-bottom: ${spaces.medium}px;
    font-size: ${fontSizes.large2X}px;
  }
`;

const WhyShouldUseUsSection = () => {
  return (
    <StyledWhyShouldUseUsSection>
      <StyledTitle>Why customers should use us?</StyledTitle>
      <FancyCards maxCol={2} items={ITEMS} />
    </StyledWhyShouldUseUsSection>
  );
};

export default WhyShouldUseUsSection;
